import React from "react";
import "./Footer.css";
function Footer() {
  return (
    <div>
      <footer className="footer text-center">
        <div className="container">
          <div className="row">
            {/* <!-- Footer Location--> */}
            {/* <!-- Footer Social Icons--> */}
            <div className="col-lg-6 mb-5 mb-lg-0">
              <h4 className="mb-4 footer-title">SOCIAL MEDIA</h4>
              <a
                className="btn btn-outline-light btn-social mx-1"
                href="https://www.twitter.com/arakdishant"
              >
                <i className="fab fa-fw fa-twitter"></i>
              </a>
              <a
                className="btn btn-outline-light btn-social mx-2"
                href="https://github.com/dishant-codes"
              >
                <i className="fab fa-fw fa-github"></i>
              </a>
              <a
                className="btn btn-outline-light btn-social mx-2"
                href="https://www.linkedin.com/in/dishant-arak-3249a1171/"
              >
                <i className="fab fa-fw fa-linkedin"></i>
              </a>
            </div>
            {/* <!-- Footer About Text--> */}
            <div className="col-lg-6">
              <h4 className="mb-4 footer-title">SERVICES</h4>
              <ul className="text-left">
                <li>Web Design</li>
                <li>Web Development</li>
                <li>Moblie App Development</li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
      {/* <!-- Copyright Section--> */}
      <section className="bg-dark py-4 text-center text-white">
        <div className="container">
          <small className="pre-wrap">
            Copyright &copy; 2021 All Right Reserved | This Website is made with
            ❤ by <a href="https://github.com/dishant-codes/">Dishant</a>
          </small>
        </div>
      </section>
    </div>
  );
}

export default Footer;
